import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
const styledCenter = {
  width: "fit-content",
  textAlign: "center",
  borderBottom: '10px solid',
  borderImageSource: "linear-gradient(120deg, #1890ff, #db18ff)",
  borderImageSlice: 5
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CodeSurferColumns themes={[nightOwl]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1> useRef</h1>
          <p>usePrevious example</p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
`}</code></pre>
      </Step>
      <Step mdxType="Step">
        <div style={styledCenter}>
          <h1> useRef</h1>
          <p>with Custom hook</p>
        </div>
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{` function Component() {
   const ref = useRef(null);
    const [width, height] = useSize(ref);
    // ...
    return <ElementToObserve ref={ref} />;
  }
`}</code></pre>
      </Step>
    </CodeSurferColumns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      